import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
import { useDropzone } from 'react-dropzone';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useCallback, useState } from 'react';
import { FormikTextInput } from '../components/form/FormikTextInput';
import { useTheme } from '@mui/material/styles';
import {
  Grid,
  Container,
  Typography,
  Card,
  CardHeader,
  Box,
  CardContent,
  CardActionArea,
  FormHelperText,
  Paper,
} from '@mui/material';

import { AppWidgetSummary } from '../sections/@dashboard/app';
import { useFormik } from 'formik';
import { LoadingButton } from '@mui/lab';
import * as Yup from 'yup';
import CoreApi from '../api/CoreApi';
import ReactMarkdown from 'react-markdown';

const MarkdownRenderer = ({ markdownContent }) => (
  <>
    <ReactMarkdown>{markdownContent}</ReactMarkdown>
  </>
);

export default function PdfToContentPage() {
  const theme = useTheme();
  const [output, setOutput] = useState('...');

  const formik = useFormik({
    initialValues: {
      files: [],
      topic: 'marketing',
      tone: 'professional and enthusiastic',
    },
    validationSchema: Yup.object({
      files: Yup.array().required('A pdf is required').min(1, 'At least one pdf is required'),
      topic: Yup.string().max(255).required('Topic is required'),
    }),
    onSubmit: async (values, helpers) => {
      const resp = await CoreApi.generateArticleFromPdf(values);
      console.log(resp.data);
      if (resp?.success) {
        setOutput(resp.data.output);
      } else {
        formik.setErrors(resp.errors);
      }
      helpers.setSubmitting(false);
    },
  });

  const onDrop = useCallback((acceptedFiles) => {
    formik.setFieldValue('files', [...formik.values.files, ...acceptedFiles]);
  }, []);

  const removeFile = (fileName) => {
    formik.setFieldValue(
      'files',
      formik.values.files.filter((file) => file.name !== fileName)
    );
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'application/pdf': ['.pdf'] },
  });

  return (
    <>
      <Helmet>
        <title> Dashboard | Sella AI </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Write Content from PDF
        </Typography>
        <form noValidate onSubmit={formik.handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormikTextInput formik={formik} name="topic" type={'topic'} label={'Topic'} />
            </Grid>
            <Grid item xs={12}>
              <FormikTextInput formik={formik} name="tone" type={'tone'} label={'Tone'} />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardActionArea>
                  <Box
                    {...getRootProps()}
                    sx={{
                      border: 1,
                      borderRadius: 1,
                      borderStyle: 'dashed',
                      pt: 1,
                      mt: 1,
                      minHeight: 128,
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    <input {...getInputProps()} />
                    <Typography>Drag and drop some files here, or click to select files</Typography>
                  </Box>
                  {Boolean(formik.touched.files && formik.errors.files) && (
                    <FormHelperText error id="standard-weight-helper-text-content">
                      {formik.errors.files}
                    </FormHelperText>
                  )}
                </CardActionArea>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={12} sx={{ justifyContent: 'end' }}>
              <Box sx={{ textAlign: 'right' }}>
                <LoadingButton
                  loading={formik.isSubmitting}
                  disabled={formik.isSubmitting}
                  type="submit"
                  variant={'contained'}
                >
                  Upload
                </LoadingButton>
              </Box>
            </Grid>

            <Box width="100%" />
            <Grid item xs={12}>
              {formik.values.files.map((data, index) => {
                return (
                  <Grid key={index} item xs={3} sm={3} md={3} sx={{ m: 1 }}>
                    <AppWidgetSummary
                      title={data.name}
                      total={1723315}
                      color="warning"
                      icon={'ant-design:file-filled'}
                      fileName={data.name}
                      onDelete={removeFile}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Box width="100%" />

            <Grid item xs={12} md={12} lg={12}>
              <Box>
                <Card>
                  <CardHeader title="Output" />
                  <CardContent sx={{ minHeight: '50vh' }}>
                    <MarkdownRenderer markdownContent={output} />
                  </CardContent>
                </Card>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
}
